import { IdModal } from "../../modals/IdModal";
import { createPathSelectTabInModal } from "../../show-me/path/createPathSelectTabInModal";
export var pathSelectCoopMenuTab = function (action, state$, deps) { return createPathSelectTabInModal(function () { return IdModal.Coop; }, function () { return action.tabId; })(action, state$, deps); };



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/path/pathSelectCoopMenuTab.ts
// module id = 1816
// module chunks = 3